// extracted by mini-css-extract-plugin
export default {"primaryBannerBlock":"PrimaryBannerBlock_primaryBannerBlock__GdUUY","primaryBanner":"PrimaryBannerBlock_primaryBanner__1oXOa"};